import type { ForgotPasswordParams } from "@nlc/shared-types";

import { useMutation } from "@tanstack/react-query";

import { unauthenticatedApi } from "@/lib/api/client";

export function useForgotPasswordMutation() {
  return useMutation({
    mutationFn: async ({ email }: ForgotPasswordParams) =>
      await unauthenticatedApi
        .url(`/users/forgot-password/${email}`)
        .post()
        .json(),
    mutationKey: ["forgot-password"],
  });
}
